import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import CardInteracion from '../../Components/CardInteraction/CardInteracion'
import { _formatPrice } from '../../Utils/tools'

import productImg from '../../assets/img/prescription.png'
import { addEventNameWithParams, logEvent } from '../../Utils/utils'

function PriceFinderResult() {
  const history = useHistory()
  const [loading, setLoading] = useState(true)

  const bio = history.location.state.bio
  const path = history.location.state.path

  useEffect(() => {
    setLoading(false)
  }, [])

  function goBack() {
    history.goBack()
  }

  const onClickOption = (productId, product) => {
    addEventNameWithParams('gmt_bioequivalent_selected', {
      product_name: product.product_name,
      product_id: productId,
    })
    let currPath = path.split('/')[2]
    logEvent(currPath === 'price_finder_detail' ? 'Price Finder Checked' : 'Medication Sheet Checked', {
      'Origin': 'Bioequivalent',
      'Product Id': productId,
      'Product Name': product?.product_name,
      'Lab Name': product?.laboratory_name,
    })
    history.push(path, {
      product_id: productId,
      product: product,
      isComesFromMedicationSheet: true,
    })
  }

  return (
    <>
      {process.env.REACT_APP_CLIENT_NAME !== 'UC Christus' && <div className="content-responsive mx-auto d-flex justify-content-between py-3 px-3 px-md-0">
        <div className="breadcrumbs c-pointer" onClick={goBack}>
          <a className="d-flex align-items-center">
            <i className="icon-chevron-right icon-reverse"></i>
          </a>
          <span className="title-primary--regular line-14">Volver</span>
        </div>
      </div>}
      <div className="flex-grow-1">
        <div className="content-responsive mx-auto">
          <div className="py-4 px-3 px-md-0">
            <h2 className="title-primary--xl-bold mb-3">Bioequivalentes</h2>
            <div className="content-card-product">
              {bio?.map((item, key) => (
                <CardInteracion
                  key={key}
                  id={`gtm-webapp-bioequivalent-pro-result-${key}`}
                  doAction={() => onClickOption(item?.product_id, item)}>
                  <div className="content-img-medication-sheet">
                    <img
                      src={item?.product_logo ? item?.product_logo : productImg}
                      alt={`nombre del producto`}
                      className="img-mw-35"
                    />
                  </div>
                  <div className="ml-14 overflow-hidden">
                    <h2 className="title-primary--xl-bold mb-1 line-16 pr-2 text-ellipsis--2 ">
                      {item?.product_name}{' '}
                    </h2>
                    <p className="txt-paragraph--small m-0 line-14 text-ellipsis--2 ">
                      {item?.formula_name}
                    </p>
                    <p className="txt-paragraph--small m-0 line-14 text-ellipsis--2 ">
                      {item?.presentation}
                    </p>
                    <p className="txt-paragraph--small m-0 line-14">
                      {item?.laboratory_name}
                    </p>
                    {['/pro/price_finder_detail'].includes(path) && (
                      <p className="txt-paragraph--small txt-bold mb-1">
                        Desde: {_formatPrice(item.price_from)}
                      </p>
                    )}
                  </div>
                </CardInteracion>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PriceFinderResult
